
import axios from 'axios';
import { plugin } from '@thomasphan/vue-components/src/index';
import Vue from 'vue';
import VueAxios from 'vue-axios';

Vue.use(plugin);
Vue.use(VueAxios, axios);